((app, ng) => {

    app.component("planning",
        {
            templateUrl: "/App/Client/Case/Planning/planning.html",
            controller: planningController,
            bindings: {
                clientCase: "<",
                currentUser: "<",
                client: "<"
            }
        });

    function planningController(caseApi, _investmentObjectives) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.investmentObjectives = _investmentObjectives;

            $ctrl.ui = {
                otherInvestmentObjective: !!$ctrl.clientCase.InvestmentObjective.Other,
            }
        }

        const updateInvestmentObjective = (clientCase) => {
            caseApi.updateInvestmentObjective(clientCase.Id, clientCase);
        }

        const updateInvestmentKnowledge = (clientCase) => {
            caseApi.updateInvestmentKnowledge(clientCase.Id, clientCase);
        }

        const updateRiskTolerance = (clientCase) => {
            caseApi.updateRiskTolerance(clientCase.Id, clientCase);
        }

        ng.extend($ctrl,
            {
                updateInvestmentObjective,
                updateInvestmentKnowledge,
                updateRiskTolerance,
            });
    }

})(window.app, window.angular);